/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PipelineAccessLevels = "BUILD_AND_READ" | "MANAGE_BUILD_AND_READ" | "READ_ONLY" | "%future added value";
export type TeamPipelineUpdateInput = {|
  clientMutationId?: ?string,
  id: string,
  accessLevel: PipelineAccessLevels,
|};
export type PipelinesTeamAccessLevelChangeMutationVariables = {|
  input: TeamPipelineUpdateInput
|};
export type PipelinesTeamAccessLevelChangeMutationResponse = {|
  +teamPipelineUpdate: ?{|
    +teamPipeline: {|
      +accessLevel: PipelineAccessLevels
    |}
  |}
|};
export type PipelinesTeamAccessLevelChangeMutation = {|
  variables: PipelinesTeamAccessLevelChangeMutationVariables,
  response: PipelinesTeamAccessLevelChangeMutationResponse,
|};
*/


/*
mutation PipelinesTeamAccessLevelChangeMutation(
  $input: TeamPipelineUpdateInput!
) {
  teamPipelineUpdate(input: $input) {
    teamPipeline {
      accessLevel
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessLevel",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelinesTeamAccessLevelChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamPipelineUpdatePayload",
        "kind": "LinkedField",
        "name": "teamPipelineUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamPipeline",
            "kind": "LinkedField",
            "name": "teamPipeline",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PipelinesTeamAccessLevelChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamPipelineUpdatePayload",
        "kind": "LinkedField",
        "name": "teamPipelineUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamPipeline",
            "kind": "LinkedField",
            "name": "teamPipeline",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "39b130d5aad8d9966ead7cf861a0e87f",
    "id": null,
    "metadata": {},
    "name": "PipelinesTeamAccessLevelChangeMutation",
    "operationKind": "mutation",
    "text": "mutation PipelinesTeamAccessLevelChangeMutation(\n  $input: TeamPipelineUpdateInput!\n) {\n  teamPipelineUpdate(input: $input) {\n    teamPipeline {\n      accessLevel\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b77e06d206ef48b6582ff8e9ab7f146b';

module.exports = node;
